
import { makeStyles } from '@material-ui/core/styles';

// eslint-disable-next-line import/prefer-default-export
export const useStyles = makeStyles(() => ({
  justify: {
    display: 'flex',
    justifyContent: 'flex-end',
    alignContent: 'space-between',
    alignItems: 'center',
    padding: '5px',
    '& > button': {
      background: 'red',
      fontSize: '6px',
      margin: '2px',
      color: 'white',
      '&:hover': {
        backgroundColor: '#015b88'
      },
    },
  },
}));
